import React, { useState } from "react";
import PropTypes from "prop-types";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useApi } from "../../../../../context/api.js";
import MDButton from "../../../../../components/MDButton";
import MDTypography from "../../../../../components/MDTypography";
import CircularProgress from "@mui/material/CircularProgress";
import { setMilestone, useHomework } from "../../../../../context/homework";
import activities from "../../../../../components/activities";
import MDBox from "../../../../../components/MDBox";

function ActivityValidation({ m, from, title, onCancel, activityType, ...activityParams }) {
  const api = useApi();
  const [_, dispatch] = useHomework();
  const [loading, setLoading] = useState(0);

  const handleReject = () => {
    setLoading(2);
    api
      .rejectMilestone(m.id, from)
      .then((res) => {
        setLoading(0);
        if (res) {
          setMilestone(dispatch, m.id, from);
          onCancel();
        } else {
          // TODO : Show error ?
        }
      })
      .catch((err) => {
        setLoading(false);
        // TODO : Show error ?
      });
  };
  const handleAccept = () => {
    setLoading(1);
    api
      .validateMilestone(m.id, from)
      .then((res) => {
        setLoading(0);
        if (res) {
          setMilestone(dispatch, m.id, from, null);
          onCancel();
        } else {
          // TODO : Show error ?
        }
      })
      .catch((err) => {
        setLoading(false);
        // TODO : Show error ?
      });
  };

  const activity = activityType && activities[activityType];
  const Corrector = activity && activity.Corrector;

  return (
    <>
      <DialogContent>
        {title}
        <MDTypography variant="body" component="div" mt={2}>
          {m.submitted
            ? "Voici les résultats que votre enfant a obtenu à cette activité : "
            : "Vous êtes sur le point de valider cette étape de votre enfant."}
        </MDTypography>
        {m.submitted && Corrector && (
          <MDBox
            sx={{
              p: 1,
              backgroundColor: "lightyellow",
              borderRadius: 2,
              border: "1px solid khaki",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Corrector milestoneId={m.id} from={from} />
          </MDBox>
        )}
      </DialogContent>
      <DialogActions>
        {m.submitted && (
          <MDButton variant="contained" color="error" disabled={!!loading} onClick={handleReject}>
            {loading === 2 && <CircularProgress size={24} />}
            {loading !== 2 && "Refuser son étape"}
          </MDButton>
        )}
        <MDButton variant="contained" color="success" disabled={!!loading} onClick={handleAccept}>
          {loading === 1 && <CircularProgress size={24} />}
          {loading !== 1 && "Valider son étape"}
        </MDButton>
      </DialogActions>
    </>
  );
}

ActivityValidation.propTypes = {
  m: PropTypes.object.isRequired,
  from: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.element,
  activityType: PropTypes.string,
};

export default ActivityValidation;
